<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
    scrollable
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        small
        :disabled="!promotion.isReallyActive"
      >
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat tile>
        <v-card-title>{{ $t("addPromotionUser.title") }}</v-card-title>
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text :style="$vuetify.breakpoint.mobile && 'height:800px'">
        <div class="px-8 py-4">
          <span class="overline font-weight-bold">
            {{ $t("promotion") }}
          </span>
          <br />
          <div class="body-2 px-4 pt-2">
            <ul>
              <li>ID: {{ promotion.id_promo }}</li>
              <li>{{ $t("code") }}: {{ promotion.code_promo }}</li>
              <li>
                {{ $t("type") }}: {{ transformTypePromo(promotion.type_promo) }}
              </li>
            </ul>
          </div>
        </div>
        <div v-if="oldTitlePromo" class="px-8 pb-2">
          <span class="overline font-weight-bold">
            {{ $t("attention") }}
          </span>
          <br />
          <div class="body-2 mb-2 pt-2 px-4">
            <div class="mt-2">
              {{
                $t("addPromotionUser.infoUser", { titlePromo: oldTitlePromo })
              }}
            </div>
          </div>
        </div>
        <div class="pa-2">
          <v-autocomplete
            v-model="searchSelectedUser"
            :items="searchUserItems"
            :loading="searchUserIsLoading"
            :search-input.sync="searchSync"
            @change="setUserId"
            prepend-icon="mdi-account"
            :label="$t('searchPlayer')"
            item-text="ui"
            item-value="id"
            clearable
            @click:clear="clearable()"
            dense
            filled
            hide-details
            solo-inverted
            return-object
            :filter="filter"
            :no-data-text="$t('autoCompleteNoData')"
            :footer-props="{
              'items-per-page-text': this.$t('rowsPerPage'),
            }"
          ></v-autocomplete>
          <span class="caption ml-10">{{ $t("seachPlayersMsg") }}.</span>
        </div>
        <v-data-table
          v-if="userId && isDeposit && !searchDepositIsLoading"
          :headers="headers"
          :items="listDepositsUser"
          class="addPromotionUser elevation-1 py-2"
          single-select
          item-key="deposit_id"
          show-select
          :no-data-text="noDepositsText"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:[`item.data-table-select`]="{ item }">
            <div class="d-flex justify-start">
              <v-radio-group v-model="selectedDeposit">
                <v-radio
                  :value="item.deposit_id"
                  :label="
                    $vuetify.breakpoint.mobile
                      ? $t('addPromotionUser.selectDeposit')
                      : ''
                  "
                ></v-radio>
              </v-radio-group>
            </div>
          </template>
          <template v-slot:[`item.deposit_id`]="{ item }">
            <v-btn @click="$copy(item.deposit_id)" x-small>
              {{ item.deposit_id }}
            </v-btn>
          </template>
          <template v-slot:[`item.value_consolidated`]="{ item }">
            <span :class="getColor(item.value_consolidated)">{{
              item.value_consolidated
            }}</span>
          </template>
          <template v-slot:[`item.id_user`]="{ item }">
            <v-btn @click="$copy(item.id_user)" x-small>
              {{ item.id_user }}
            </v-btn>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div v-html="item.status"></div>
          </template>
        </v-data-table>
        <v-skeleton-loader
          v-if="isDeposit && searchDepositIsLoading"
          type="table-heading, divider, table-row, divider, table-row, divider, table-tfoot"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          type="submit"
          @click.prevent="closeDialog"
          :loading="searchUserIsLoading"
          :disabled="searchUserIsLoading"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          type="submit"
          color="primary"
          @click="addPromotionUser()"
          :loading="searchUserIsLoading"
          :disabled="searchUserIsLoading"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "AddPromotionUser",
  props: ["promotion"],
  data: () => ({
    dialog: false,
    userId: null,
    oldTitlePromo: null,
    searchSelectedUser: null,
    searchUserItems: [],
    searchUserIsLoading: false,
    searchSync: null,
    term: "",
    sigla: "",
    listDepositsUser: null,
    selectedDeposit: null,
    noDepositsText: "",
    searchDepositIsLoading: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("depositID"),
          value: "deposit_id",
          sortable: false,
        },
        {
          text: this.$t("value"),
          value: "value_consolidated",
        },
        {
          text: this.$t("dateHour"),
          value: "deposit_date",
          sortable: true,
        },
        {
          text: this.$t("idUser"),
          value: "id_user",
          sortable: true,
        },
        {
          text: this.$t("status"),
          value: "status",
          sortable: false,
        },
      ];
    },
    isDeposit() {
      return this.promotion.type_promo === "cadastro" ||
        this.promotion.type_promo === "afiliado"
        ? false
        : true;
    },
  },
  methods: {
    clearable() {
      this.userId = null;
      this.searchUserItems = [];
    },
    reset() {
      this.clearable();
      this.listDepositsUser = [];
      this.selectedDeposit = null;
      this.oldTitlePromo = null;
    },
    closeDialog() {
      this.reset();
      this.dialog = false;
    },
    setFeedbackSnack(msg, color) {
      this.$store.commit("setFeedbackSnack", {
        msg: this.$t(msg),
        color: color,
      });
    },
    setUserId(player) {
      if (!player) {
        this.reset();
      }
      this.userId = player ? player.id : "";

      this.userId &&
        this.$request
          .post("administrator/promotions/getPlayerActivePromotion", {
            id_user: this.userId,
          })
          .then((res) => {
            this.oldTitlePromo = res.dados.active_promotion.titulo;
          });

      this.userId && this.isDeposit && this.getListDeposits();
    },
    async getPlayersSearch() {
      this.searchUserIsLoading = true;
      try {
        const response = await this.$request.post(
          "administrator/players/search",
          {
            term: this.term,
          }
        );

        if (response.length == 0) {
          this.searchUserItems = [];
          return;
        }

        this.searchUserItems =
          response &&
          response.dados.map((item) => ({
            ui: `${item.nome} (${item.login} ${item.id})`,
            id: item.id,
            name: item.nome,
            icon: item.online,
            login: item.login,
            cpf: item.cpf ? item.cpf : "not registered",
            celular: item.celular ? item.celular : "not registered",
            email: item.email ? item.email : "not registered",
          }));
      } finally {
        this.searchUserIsLoading = false;
      }
    },
    getListDeposits() {
      this.searchDepositIsLoading = true;

      this.$axios
        .post(
          "administrator/promotions/listPlayerConsolidatedDepositsByIdPromo",
          this.$formdata({
            id_promo: this.promotion.id_promo,
            id_user: this.userId,
          })
        )
        .then((deposits) => {
          if (deposits.data.length === 0) {
            this.listDepositsUser = [];
            this.searchDepositIsLoading = false;
            return;
          }

          if (this.promotion.type_promo === "1ºdeposito") {
            this.listDepositsUser = [deposits.data.dados];
            this.listDepositsUser[0].deposit_id = deposits.data.dados.id;
            this.listDepositsUser[0].deposit_date = new Date(
              deposits.data.dados.date_final.replace(" ", "T")
            ).toLocaleString();
            this.listDepositsUser[0].status = this.statusOperationUI(
              deposits.data.dados.status
            );

            this.promotion.type_promo === "1ºdeposito" &&
              (this.selectedDeposit = this.listDepositsUser[0].deposit_id);
            this.searchDepositIsLoading = false;
            return;
          }

          this.listDepositsUser = deposits.data.dados;

          this.listDepositsUser.forEach((item) => {
            item.deposit_id = item.id;
            item.deposit_date = new Date(
              item.date_final.replace(" ", "T")
            ).toLocaleString();
            item.status = this.statusOperationUI(item.status);
          });

          this.listDepositsUser.length === 1 && (this.selectedDeposit = this.listDepositsUser[0].deposit_id);

          this.searchDepositIsLoading = false;
        })
        .catch((error) => {
          this.listDepositsUser = [];
          this.noDepositsText = error.response.data.messages.error;
          this.searchDepositIsLoading = false;
        });
    },
    async addPromotionUser() {
      if (!this.userId) {
        this.setFeedbackSnack("addPromotionUser.error.selectPlayer", "warning");
        return;
      } else if (this.isDeposit && !this.selectedDeposit) {
        if (this.listDepositsUser.length === 0) {
          this.setFeedbackSnack("addPromotionUser.error.noDeposits", "warning");
          this.reset();
          return;
        }

        this.setFeedbackSnack(
          "addPromotionUser.error.selectDeposit",
          "warning"
        );
        return;
      }

      this.searchUserIsLoading = true;
      try {
        await this.$request
          .post("administrator/promotions/addUserToPromotion", {
            id_promo: this.promotion.id_promo,
            id_user: this.userId,
            ...(this.isDeposit && { id_deposit: this.selectedDeposit }),
          })
          .then((res) => {
            if (res.messages) {
              this.$store.commit("setFeedbackSnack", {
                msg: res.messages,
                color: "success",
              });
            }
          });
        this.userId = null;
      } finally {
        this.searchUserIsLoading = false;
        this.dialog = false;
      }
    },
    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    statusOperationUI(value) {
      const obj = {
        1: `<span class="my-1 v-chip theme--light v-size--small orange darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "requisted"
        )}</span></span>`,
        2: `<span class="my-1 v-chip theme--light v-size--small grey darken  white--text"><span class="v-chip__content">${this.$t(
          "authorized"
        )}</span></span>`,
        3: `<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">${this.$t(
          "consolidated"
        )}</span></span>`,
        4: `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content">${this.$t(
          "didCancelled"
        )}</span></span>`,
      };
      return obj[value];
    },
    transformTypePromo(type_promo) {
      const map = {
        afiliado: this.$t("affiliate"),
        cadastro: this.$t("register"),
        deposito: this.$t("deposit"),
        "1ºdeposito": this.$t("firstDeposit"),
      };
      return map[type_promo] || null;
    },
    removeAccents(str) {
      let string = str;

      const mapAccentsHexCode = {
        a: /[\xE0-\xE6]/g,
        A: /[\xC0-\xC6]/g,
        e: /[\xE8-\xEB]/g,
        E: /[\xC8-\xCB]/g,
        i: /[\xEC-\xEF]/g,
        I: /[\xCC-\xCF]/g,
        o: /[\xF2-\xF6]/g,
        O: /[\xD2-\xD6]/g,
        u: /[\xF9-\xFC]/g,
        U: /[\xD9-\xDC]/g,
        c: /\xE7/g,
        C: /\xC7/g,
        n: /\xF1/g,
        N: /\xD1/g,
      };

      for (let letter in mapAccentsHexCode) {
        let regex = mapAccentsHexCode[letter];
        string = string.replace(regex, letter);
      }

      return string;
    },
    filter(item, queryText) {
      let fields = ["id", "name", "login", "celular", "email", "cpf", "ui"];

      for (let field of fields) {
        if (
          this.removeAccents(item[field].toLocaleLowerCase()).includes(
            this.removeAccents(queryText.toLocaleLowerCase())
          )
        ) {
          return item;
        }
      }
    },
  },
  watch: {
    userId() {
      if (!this.userId) {
        this.reset();
      }
    },
    searchSync(val) {
      // Caso o usuário selecionar um usuário da lista
      // não permitir realizar o get novamente.
      // O regex abaixo identifica os caracteres "(" e ")"
      // Contido na string e encerra dando return.
      if (/\(|\)/.test(val)) return;

      if (!val) {
        this.searchUserItems = [];
        this.sigla = "";
        this.term = "";
        return;
      }
      if (this.searchUserIsLoading) return;
      if (val.length != 3) {
        val = val.substring(0, 3);
        if (val.length != 3) {
          return;
        }
      }
      this.sigla = val;
      if (val.length >= 3 && val != this.term) {
        this.term = val;
        this.getPlayersSearch();
      }
    },
  },
};
</script>

<style>
.addPromotionUser
  .v-data-table__mobile-table-row
  .v-data-table__mobile-row:first-child {
  justify-content: start;
}

.v-data-table-header th {
  white-space: nowrap;
}
</style>
